import { Address } from '../types/address';

interface HiddenAddressFormInputsProps {
  address: Address;
}

export default function HiddenAddressFormInputs({
  address,
}: HiddenAddressFormInputsProps) {
  return (
    <>
      <input type="hidden" name="address1" value={address.address1} />
      <input type="hidden" name="address2" value={address.address2} />
      <input type="hidden" name="city" value={address.city} />
      <input type="hidden" name="state" value={address.state} />
      <input type="hidden" name="zipcode" value={address.zipcode} />
    </>
  );
}
